import { AuthService, PamlabApiServiceService } from '@/shared/services';
import { DropDownAnimation } from './animations';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TrackingService } from '@/shared/services/tracking.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  animations: [DropDownAnimation],
  standalone: false,
})
export class NavbarComponent implements OnInit {
  public isOpen = false;
  public env = environment;

  constructor(
    public authService: AuthService,
    public apiService: PamlabApiServiceService,
    private trackingService: TrackingService,
  ) {}

  ngOnInit(): void {}

  // logged user out
  userLogout() {
    this.trackingService.trackActions();
    this.authService.logout();
  }
}
